









import {
  Vue,
  Component,
  Prop,
  Provide,
  Emit,
  Watch,
  Inject,
} from "vue-property-decorator";
import echart from 'echarts';
import Empty from './Empty.vue'
@Component({
  components: {Empty},
})

export default class LineView extends Vue {
    @Prop()
    public name!:string;
    @Prop()
    public width!: Number;
    @Prop()
    public height!: Number;
    @Prop()
    public labelName!: string;
    @Prop()
    public lineCorlor!: string;
    @Prop()
    public data? : Array<any>;
    public mychart : any;
    public show : boolean = true;

    @Watch('data',{deep: true})
    public dataChange(newVal : any,oldVal : any) {
         if (!newVal || newVal.length > 0) {
            if(!this.show) {
                this.show = true;
            }
           setTimeout(() => {
                this.draw();
           }, 100);
          
        }
    }

    public draw() {
        let dom = document.getElementById(this.name) as any;
        dom.style.height = this.height  + 'px';
        this.mychart = echart.init(dom);
        let option = {
            color: [this.lineCorlor],
            legend: {
                data: ['数量'],
                formatter: this.labelName,
            },
              tooltip: {
                trigger: 'axis'
              },
              grid: {
                x: 45,
                y: 25,
                x2: 25,
                y2: 60
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: this.data?.map(value => value.date),
                axisLabel : {
                    rotate: 40
                }
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                data: this.data?.map(value => value.num),
                name: '数量',
                type: 'line',
                areaStyle: {
                    opacity: 0.1
                }
                }
            ]
        };
        this.mychart.setOption(option);
    }

    public resize() {
        if (this.show) {
            this.mychart.resize();
        }
    }


    mounted() {
        if (!this.data || this.data.length == 0) {
            this.show = false;
        }
        window.addEventListener('resize',()=> {
             this.resize()
        })
        const tempThis = this as any;
        if(tempThis.$bus) {
        tempThis.$bus.$on('collapseChange',() => {
        setTimeout(() => {
            this.resize()
        }, 300);
        });
        }
    }
}
